export default {"src":"/_next/static/media/MTG.e029133d.svg","height":18,"width":18};